import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiBarChart = {
  defaultProps: {
    colors: capitalCategoricalPalette,
    enableKeyboardNavigation: true
  }
};
export {
  MuiBarChart
};
//# sourceMappingURL=MuiBarChart.js.map
